export interface ILanguagePaging {
    numOfPages: number;
    pages: any;
    common?: any;
    alerts?: any
}

const english: ILanguagePaging = {
    "numOfPages": 10,
    "pages": {
        "0": {
            "signup": "SIGN UP",
            "newUser": "New User",
            "acc_ur_data": "Access your data",
            "req_btn_clb": "REQUEST A BENNET CLUB"
        },
        "1": {
            "title": "REGISTRATION",
            "cardNum": "Card Number",
            "card_tip": "13 digits are presented on the back of the card",
            "do_you_have": "Are you already had a ",
            "dnt_hv_cf": "I declare that i do not have a fiscal code",
            "hint": "fiscal code mandatory for residents in Italy",
            "forget_number": "I don't remember the card number !",
            "forget_number_detail": "Contact The Client Service on the number <a tabindex=\"-1\" href='tel:800236638'><strong>800236638</strong></a><br>From Mondy to Sunday <strong>The time FROM  09,00  TO  21,00</strong><br>Freely except for mobile call <br>From aboard <a tabindex=\"-1\" href='tel:+39 031 44 92 734' color:#6c757d >+39 031 44 92 734</a>. is paid .",
            "forget_number_detail_totem": "Contact The Client Service on the number <a tabindex=\"-1\" href='tel:800236638'><strong>800236638</strong></a><br>From Mondy to Sunday <strong>The time FROM  09,00  TO  21,00</strong><br>Freely except for mobile call <br>From aboard <a tabindex=\"-1\" href='tel:+39 031 44 92 734' color:#6c757d >+39 031 44 92 734</a>. is paid .",
            "reset_pwd": "Reset password",
            "user_exist": "USER ALREADY EXISTED",
            "hint_ddn": "obbligatorio inserire la tua data di nascita",
            "stiboRegMaintenance": "Sito in Manutenzione",
            "stiboRegMaintenance1": "Servizio di Registrazione momentaneamente non disponibile per manutenzione in corso.",
            "stiboRegMaintenance2": "Ci scusiamo per il disagio. Si prega di riprovare più tardi.",
            "continue": "Continue"
        },
        "2": {
            "change": "password",
            "label": "Update the password",
            "title": "Reset Password",
            "backto": "Back To ",
            "send": "Send",
            "confirmation": "You will receive a confirmation link on your email to change your password",
            "new": "new",
            "reset": "Reset",
            "rule": "Rules for creating the password",
            "r1": "It must be at least 8 characters",
            "r2": "It must contain at least one upper case letter",
            "r3": "It must contain at least one lower case letter",
            "r4": "It must contain at least one number",
            "r5": "It must contain at least one simbol: !@#$%^&*_",
            "insert_new_pwd": "Insert a new password",
            "change_pwd": "Insert a new password ( different from the previous one)",
            "stiboRPMaintenance": "Sito in Manutenzione",
            "stiboRPMaintenance1": "Servizio di Reset Password momentaneamente non disponibile per manutenzione in corso.",
            "stiboRPMaintenance2": "Ci scusiamo per il disagio. Si prega di riprovare più tardi."
        },
        "3": {
            "page1_bc": "REQUEST A BENNET CLUB",
            "page1_create_account": "REGISTRATION",
            "page2": "CONTROL CODE",
            "page3": "DATA OF ACCESS TO THE PORTAL BENNET",
            "page4": "YOUR PREFERENCES",
            "page5": "Start Your Shopping Now",
            "stiboBCMaintenance": "Sito in Manutenzione",
            "stiboBCMaintenance1": "Servizio di Registrazione momentaneamente non disponibile per manutenzione in corso.",
            "stiboBCMaintenance2": "Ci scusiamo per il disagio. Si prega di riprovare più tardi.",
            "continue": "Continue",
            "back":"Back"
        },
        "4": {
            "gender": "Gender",
            "genders": { "male": 'MALE', "female": 'FEMALE' },
            "dnt_hv_cf": "I dont have a fiscal code ",
            "dnt_hn_email": "I dont have an email",
            "phone_num": "Phone Number",
            "nationality": "Nationality",
            "ldn": "Place of birth",
            "residence": "Residence",
            "city": "City",
            "province": "Provincià",
            "address": "Address",
            "hint": "mandatory for residents in Italy",
            "profile": "your profile",
            "placeholder": "Municipality for people born in Italy, otherwise specify Nation",
            "personal_info": "personal information",
            "street_number_msg": "Maximum length is 6 characters"
        },
        "5": {
            "title": "CONTROL CODE",
            "resend": "RESEND",
            "phone": "Phone Number",
            "email": "E-MAIL Address",
            "str1": "An alphanumeric code has been sent to your email address",
            "str2": "or to your mobile phone with a text message.",
            "str3": "Send me the code with an SMS to the number",
            "str4": "I have not received the email, send me to this address",
            "str5": "At this moment it is impossible to communicate ",
            "str6": "BY Email or SMS",
            "insert": "Insert the code here",
            "confirm_details": "The confirmation code is generally sent within a few moments<br> Please wait at least 30 seconds before requesting a new confirmation code"
        },
        "6": {
            "title": "DATA OF ACCESS TO THE PORTAL BENNET",
            "question": "Why is it important to have a BENNET.COM account",
	    "info1": "Creare una utenza sui nostri portali è obbligatorio, completa la registrazione del tuo account Bennet scegliendo una password.",
            "info2": "Se lo desideri puoi completare la registrazione del tuo account Bennet scegliendo una password, per usufruire di tutti i vantaggi a te riservati. Creare una utenza sui nostri portali non è obbligatorio.",
            "list": "By logging in you can",
            "l1": "Access directly to your data card",
            "l2": "Control the points balance of your Bennet Club",
            "l3": "Take advantage of the services dedicated to the users of Bennet ",
            "l4": "Receive preview promotions",
            "l5": "Receive discounts that Bennett has designed just for you",
            "l6": "Buy online now on BENNETDRIVE.IT",
            "option": "I do not want an account",
            "rule": "Rules for creating the password",
            "r1": "It must be at least 8 characters",
            "r2": "It must contain at least one upper case letter",
            "r3": "It must contain at least one lower case letter",
            "r4": "It must contain at least one number",
            "r5": "It must contain at least one simbol: !@#$%^&*_",
            "remember": "Qualora tu voglia proseguire senza creare una utenza sui nostri portali seleziona il box "
       },
        "7": {
            "header": "YOUR PREFERENCES",
            "title_1": "FAVOURIT SALES POINT",
            "title_2": "INTERESTS",
            "title_2_desc": "Possibile selezionare anche più di una opzione",
            "title_3_0": "REGOLAMENTO CARTA",
            "title_3": "DATA PROCESSING",
            "title_4": "HOW YOU PREFER TO CONTACT WITH YOU",
            "title_5": "AUTHENTICATION TWO FACTOR",
            "stiboMaintenance": "Sito in Manutenzione",
            "stiboMaintenance1": "Servizio di Modifica Dati momentaneamente non disponibile per manutenzione in corso.",
            "stiboMaintenance2": "Ci scusiamo per il disagio. Si prega di riprovare più tardi.",
            "mfa1": "Enabling access via OTP code",
            "mfa11": "Frame with the camera to activate MFA in the app: Authenticator",
            "mfa11a": " or Google Authenticator",
            "mfa11b": ") :",
            "mfa12": "Enter the 6-digit code generated in the app (Authenticator or Google Authenticator) in the following box:",
            "mfatitle": "Autenticazione a due fattori avvenuta con successo!",
            "mfaError": "Errore di autenticazione",
            "mfaError1": "Ti invitiamo a riprovare il processo di attivazione dell'autenticazione a due fattori.",
            "mfaError2": "Il codice di verifica OTP ha una validità di 30 secondi ed una lunghezza di 6 cifre.",
            "mfa13App": "Complimenti! Salva ora i dati del Tuo Profilo Bennet e conserva la",
            "mfa14App": "configurazione nell’APP di Autenticazione per i prossimi accessi.",
            "mfa15App": "Ricorda che puoi sempre cambiare le tue impostazioni.",
            "mfa13Sms": "Complimenti! Salva ora i dati del Tuo Profilo Bennet ",
            "mfa14Sms": "Invieremo un SMS al tuo numero per i prossimi accessi.",
            "mfa15Sms": "Ricorda che puoi sempre cambiare le tue impostazioni.",
            "mfa21": "Clicca per generare il codice OTP e inviarlo via SMS<br><small>( Potrebbero essere applicate tariffe dal tuo operatore telefonico, verifica il tuo piano tariffario )</small>",
            "mfa22": "Invia OTP",
            "mfa23": "Inserisci qui sotto il codice a 6 cifre ricevuto tramite SMS",
            "mfa24": "Codice:",
            "mfa25": "Account:",
            "mfa26": "Tipo:",
            "mfa27": "In base all'ora",
            "p1": "For collecting prizes ",
            "p2": "For receiving promotions",
            "p3": "For online shopping on BennetDrive.IT",
            "int0": "Car",
            "int1": "Children",
            "int2": "Do It Your Self",
            "int3": "Gardening",
            "int4": "Animals",
            "int5": "Bio and Healthy",
            "int6": "Technology",
            "int7": "Gourmet and Wines",
            "int8": "Sport and Free time ",
            "pvc0": "Privacy",
            "pvc1": "Marketing",
            "pvc2": "Profilazione",
            "pvc3": "Consent Sending Mail",
            "pvc4": "Consent Sending SMS / MMS",
            "pvc5": "Consent Telephone ",
            "pvc6": "Consent Mailing",
            "pvc7": "Consent Sending Instant Message",
            "pvc0-detail": "Effettuando la registrazione dichiaro di aver letto e compreso l'INFORMATIVA SUL TRATTAMENTO DEI DATI.",
            "pvc1-detail": "Rispetto alla finalità G) di marketing diretto, per ricevere materiale informativo promozionale e pubblicitario relativo ai prodotti di Bennet Spa.",
            "pvc2-detail": "Rispetto alla finalità H) di profilazione, ossia ricevere comunicazioni promozionali e pubblicitarie di mio interesse correlate ai gusti manifestati in base ai miei acquisti.",
            "accept": "ACCEPT ",
            "not_accept": "NOT ACCEPT "
        },
        "8": {
            "title": "RETRIEVE CARD",
            "message": "ENTER YOUR DATA AND YOUR CARD WILL BE SENT TO YOU IN OUR DATABASE",
            "phone_num": "Phone Number",
            "btn_label": "Back to Registration",
            "send": "Send a forgotten card to your e-mail address via SMS",
            "reprint": "Reprint your card to the information box !"
        },
        "9": {
            "title": "Start Your Shopping Now",
            "notification": "An email has been sent to your email address with the digital copy of the card and all the supporting information",
            "sol1para1": "You will receive an email with your card at your email address",
            "sol1para2": "Together with a virtual copy of the card you will receive the rules and privacy via email.",
            "sol2para1": "You will receive an SMS with the code of your card at the number",
            "sol2para2": "You can request the printing of your card from the information box by presenting the SMS and having a copy of the privacy policy that you can always find on Bennet.com",
            "solution": "SOLUTION"
        }
    },
    "common": {
        "language": "english",
        "name": "Name",
        "surname": "Surname",
        "cf": "Fiscal Code",
        "ddn": "Date of birth",
        "next": "NEXT",
        "exit": "EXIT",
        "save": "SAVE",
        "cancel": "Cancel",
        "try": "Try again",
        "required": "required",
        "yes": "YES",
        "retrive": "RETRIVE",
        "modify": "Modify",
        "use": "Use",
        "invalid": "Invalid",
        "worning": "Worning",
        "updated": "Updated Successfully",
        "error": "Error",
        "not_recognized": "USER NOT RECOGNIZED",
        "confirm": "CONFIRM",
        "remit": "RIMETTI",
        "registrtaion": "registrtaion",
        "control_inserted_fields": "CONTROL THE INSERTED FIELDS",
        "close": "Close"

    },
    "alerts": {
        "alert_1": "L'utente è gia registrato con indirizzo email XXXX <br><br><span class ='small text-muted bolded'>  Se non ricordi i tuoi codici di accesso utilizza il servizio di RECUPERA PASSWORD o contatta il Servizio Clienti Bennet scrivendo a servizio.clienti@bennet.com o telefonando all’800236638</span>",
        "alert_2": "Il Codice Fiscale  XXXX è già in uso.<br> Ti preghiamo di contattare il Servizio Clienti Bennet all’800 236638 o scrivere a servizio.clienti@bennet.com",
        "alert_3": "L’email XXXX  è già in uso.<br> Ti preghiamo di contattare il Servizio Clienti Bennet all’800 236638 o scrivere a servizio.clienti@bennet.com",
        "alert_4": "Formato Email non valido per XXXX, formato corretto: example@example.it",
        "alert_5": "Il codice fiscale inserito non è coerente con i dati inseriti. <br>Ricontrolla i dati anagrafici e Codice Fiscale ",
        "alert_6": "Il numero XXXX risulta invalido.",
        "alert_7": "L'indirizzo email  XXXX risulta invalido.",
        "alert_8": "Ti abbiamo inviato un SMS con il codice di controllo al numero: XXXX",
        "alert_9": "Ti abbiamo inviato un Email con il codice di controllo all'indirizzo: XXXX",
        "alert_10": "Ti preghiamo di controllare che i dati personali e il numero della <br> Carta Bennet Club siano correttamente inseriti.<br> <br>Ti preghiamo inoltre di verificare che Nome e Cognome <br> corrispondano a quelli forniti all'emissione della Carta.<br> <br>Qualora la Carta sia stata creata da un familiare occorre inserire i suoi <br> riferimenti anagrafici (nome e cognome).",
        "alert_11": "Hai già una Carta attiva, ti invitiamo a <strong>Recuperare la Carta </strong>.<br><br>Se smarrita contatta il Servizio Clienti al numero <a tabindex=\"-1\" href='tel:800236638'><strong>800236638</strong></a><br>Dal lunedì alla domenica <strong>dalle ore 09,00 alle ore 21,00</strong><br>Gratuito ad esclusione di chiamata da telefoni cellulari<br>Dall'estero <a tabindex=\"-1\" href='tel:+39 031 44 92 734' color:#6c757d >+39 031 44 92 734</a>. ",
        "alert_12": "Il CAP dovrebbe essere composto da 5 numeri",
        "alert_13": "La password non soddisfa le regole",
        "alert_14": "La password di conferma non corrisponde alla password inserita",
        "alert_15": "Utente già presente in anagrafica con Carta attiva! Per maggiori informazioni contatta il Servizio Clienti Bennet scrivendo a servizio.clienti@bennet.com o telefonando all’800236638 ",
        "alert_16": "Il codice fiscale inserito non è coerente con i dati inseriti <br>Ricontrolla i dati anagrafici e Codice Fiscale",
        "alert_17": "In questo momento sono impossibilitato a ricevere comunicazioni via SMS",
        "alert_18": "Il codice inserito non è corretto",
        "alert_19": "Inserisci il codice per favore!",
        "alert_20": "Sei sicuro di voler recuperare le vecchie informazioni?",
        "alert_21": "Sei sicuro di voler uscire?<br><br><span class='small'> Perderai le informazioni appena inserite</span>",
        "alert_22": "Aggiornamento eseguito correttamente",
        "alert_23": "Non è possibile aggiornare le informazioni in questo momento. Ci scusiamo per il disagio",
        "alert_24": "Scegli il tuo bennet drive preferito",
        "alert_25": "Scegli il tuo Punto Vendita Preferito",
        "alert_26": "Scegli il tuo Punto Vendita di ritiro premi",
        "alert_27": "Scegli come preferisci essere contattato'",
        "alert_28": "Non è possibile proseguire senza il consenso Privacy",
        "alert_29": "Invio della mail non eseguito, Ricontrolla la mail, deve essere la stessa con la quale ti sei registrato",
        "alert_30": "La richiesta è stata effettuata, a breve riceverai una mail per la scelta della nuova password ",
        "alert_31": "La password è stata resettata correttamente",
        "alert_32": "Errore tecnico. Ci scusiamo per il disagio",
        "alert_33": "ERRORE NEI DATI CARTA CONTATTA IL SERVIZIO CLIENTI",
        "alert_34": "Il CAP dovrebbe essere al massimo composto da 5 numeri",
        "alert_35": "Il Codice di controllo dovrebbe essere da 5 numeri",
        "alert_36": "Devi compilare tutti i dati obbligatori ",
        "alert_37": "L'email per il reset della password non è più valida. Richiedi un altro invio.",
        "alert_38": "Inserisci un indirizzo di Residenza Valido (obbligatorio selezionare una delle proposte).",
        "alert_39": "Il civico dovrebbe essere al massimo composto da 6 caratteri",
        "alert_40": "Formato Codice Fiscale non valido per XXXX",
        "alert_41": "Nome e Cognome devono avere al massimo 30 caratteri",
        "alert_42": "L'utente è già presente con un'altra tessera <br><span> se scegli di proseguire la card XXXX verrà disattivata perché hai già una tessera</span>",             
        "alert_43": "Sei già registrato!",    
        "alert_44": "Registrazione riservata a clienti maggiorenni",
        "alert_45": "Completa il processo di attivazione per l'autenticazione a due fattori oppure scegli 'No MFA' ",
        "alert_46": "Abbiamo inviato il codice OTP tramite SMS al numero: XXXX, controlla il tuo dispositivo.",
        "alert_47": "Non è stato possible inviare il codice OTP tramite SMS.Riprova più tardi.", 
        "alert_48": "Attenzione: La Password scelta non può essere uguale alla precedente."     
    }
}

const italian: ILanguagePaging = {
    "numOfPages": 10,
    "pages": {
        "0": {
            "signup": "REGISTRATI",
            "newUser": "Nuovo Utente",
            "acc_ur_data": "Accedi ai tuoi dati",
            "req_btn_clb": "RICHIEDI LA TUA BENNET CLUB"
        },
        "1": {
            "title": "REGISTRAZIONE",
            "cardNum": "Inserisci numero della Bennet Club",
            "card_tip": "Deve essere di 13 cifre e lo trovi riportato sul retro della carta",
            "do_you_have": "Sei già in possesso di una ",
            "dnt_hv_cf": "Dichiaro di non essere in possesso di codice fiscale",
            "hint": "obbligatorio per residenti in Italia",
            "forget_number": "Non ti ricordi il numero della carta?",
            "forget_number_detail": "Contatta il Servizio Clienti al numero <a tabindex=\"-1\" href='tel:800236638'><strong>800236638</strong></a><br>Dal lunedì alla domenica <strong>dalle ore 09,00 alle ore 21,00</strong><br>Gratuito ad esclusione di chiamata da telefoni cellulari<br>Dall'estero <a tabindex=\"-1\" href='tel:+39 031 44 92 734' color:#6c757d >+39 031 44 92 734</a>. Oppure puoi contattarci su <br> <a tabindex=\"-1\" href='https://www.bennet.com/customerCare' target='_blank'><strong>www.bennet.com/customerCare</strong></a>",
            "forget_number_detail_totem": "Contatta il Servizio Clienti al numero <strong>800236638</strong><br>Dal lunedì alla domenica <strong>dalle ore 09,00 alle ore 21,00</strong><br>Gratuito ad esclusione di chiamata da telefoni cellulari<br>Dall'estero +39 031 44 92 734. Oppure puoi contattarci su <br> <strong>www.bennet.com/customerCare</strong>",
            "reset_pwd": "Recupera password",
            "user_exist": "UTENTE GIA’ REGISTRATO",
            "hint_ddn": "obbligatorio inserire la tua data di nascita",
            "stiboRegMaintenance": "Sito in Manutenzione",
            "stiboRegMaintenance1": "Servizio di Registrazione momentaneamente non disponibile per manutenzione in corso.",
            "stiboRegMaintenance2": "Ci scusiamo per il disagio. Si prega di riprovare più tardi.",
            "continue": "Continua"

        },
        "2": {
            "change": "password",
            "label": "Modifica la password",
            "title": "Cambia Password",
            "backto": "Torna a ",
            "send": "Invia",
            "confirmation": "Inserisci la tua email di registrazione, riceverai un link per cambiare la password",
            "new": "nuova",
            "reset": "Ripristina",
            "rule": "Regole per la creazione della password",
            "r1": "Deve essere di almeno 8 caratteri",
            "r2": "Deve contenere almeno una lettera maiuscola",
            "r3": "Deve contenere almeno una lettera minuscola",
            "r4": "Deve contenere almeno un numero",
            "r5": "Deve contenere almeno un simbolo: !@#$%^&*_",
            "insert_new_pwd": "Inserisci una nuova password",
            "change_pwd": "Inserisci una nuova password ( diversa dalla precedente)",
            "stiboRPMaintenance": "Sito in Manutenzione",
            "stiboRPMaintenance1": "Servizio di Reset Password momentaneamente non disponibile per manutenzione in corso.",
            "stiboRPMaintenance2": "Ci scusiamo per il disagio. Si prega di riprovare più tardi."
        },
        "3": {
            "page1_bc": "RICHIEDI LA TUA BENNET CLUB",
            "page1_create_account": "REGISTRAZIONE",
            "page2": "CODICE DI CONTROLLO",
          //  "page3": "DATI DI ACCESSO AL PORTALE BENNET",
            "page3": "CREA ACCESSO AL PORTALE BENNET",
            "page4": "LE TUE PREFERENZE",
            "page5": "Inizia Subito La Tua Spesa",
            "stiboBCMaintenance": "Sito in Manutenzione",
            "stiboBCMaintenance1": "Servizio di Registrazione momentaneamente non disponibile per manutenzione in corso.",
            "stiboBCMaintenance2": "Ci scusiamo per il disagio. Si prega di riprovare più tardi.",
            "continue": "Continua",
            "back":"Indietro"
        },
        "4": {
            "gender": "Sesso",
            "genders": { "male": 'MASCHIO', "female": 'FEMMINA' },
            "dnt_hv_cf": "Dichiaro di non essere in possesso di codice fiscale",
            "dnt_hn_email": "Non possiedo una mail",
            "phone_num": "Cellulare",
            "nationality": "Nazionalità",
            "ldn": "Luogo di nascita",
            "residence": "Stato residenza",
            "city": "Località",
            "province": "Provincia",
            "address": "Indirizzo",
            "hint": "obbligatorio per residenti in Italia",
            "profile": "il tuo profilo",
            "placeholder": "Comune per i nati in Italia, nazione per luogo di nascita estero",
            "personal_info": "informazione personale",
            "street_number_msg": "Lunghezza massima 6 caraterri"
        },
        "5": {
            "title": "CODICE DI CONTROLLO",
            "resend": "RISPEDISCI",
            "phone": "Numero Cellulare",
            "email": "Indirizzo  Email",
            "str1": "Inserisci qui il codice di controllo ricevuto al tuo indirizzo di posta elettronica ",
            "str2": "o al tuo cellulare con un SMS.",
            "str3": "Non ho ricevuto un SMS",
            "str4": "Non ho ricevuto la mail",
            "str5": "In questo momento sono impossibilitato a ricevere comunicazioni ",
            "str6": "Via EMAIL o SMS",
            "insert": "Inseriscilo qui",
            "confirm_details": "Il codice di conferma viene spedito nel giro di qualche istante <br>Ti preghiamo di attendere almeno 30 secondi<br> prima di richiedere un nuovo invio"
        },
        "6": {
            "title": "DATI DI ACCESSO AL PORTALE BENNET",
           // "title": "CREA ACCESSO AL PORTALE BENNET",
            //"question": "Perché è importante avere un account BENNET.COM ",
            "question": "Quali sono i vantaggi di avere un account",
            "info1": "Creare una utenza sui nostri portali è obbligatorio, completa la registrazione del tuo account Bennet scegliendo una password.",
            "info2": "Se lo desideri puoi completare la registrazione del tuo account Bennet scegliendo una password, per usufruire di tutti i vantaggi a te riservati. Creare una utenza sui nostri portali non è obbligatorio.",
            "list": "Effettuando il login potrai ",
            "l1": "Accedere direttamente alla scheda dei tuoi dati",
            "l2": "Controllare il saldo punti della tua Bennet Club",
            "l3": "Usufruire dei servizi dedicati agli utenti Bennet",
            "l4": "Ricevere le promozioni in anteprima",
            "l5": "Ricevere sconti che Bennet ha pensato solo per te",
            "l6": "Acquistare subito online su BENNETDRIVE",
            "option": "Non voglio un account",
            "rule": "Regole per la creazione della password",
            "r1": "Deve essere di almeno 8 caratteri",
            "r2": "Deve contenere almeno una lettera maiuscola",
            "r3": "Deve contenere almeno una lettera minuscola",
            "r4": "Deve contenere almeno un numero",
            "r5": "Deve contenere almeno un simbolo: !@#$%^&*_",
            "remember": "Qualora tu voglia proseguire senza creare una utenza sui nostri portali seleziona il box "
        },
        "7": {
            "header": "LE TUE PREFERENZE",
            "title_1": "PUNTO VENDITA PREFERITO",
            "title_2": "INTERESSI",
            "title_2_desc": "Possibile selezionare anche più di una opzione",
            "title_3_0": "REGOLAMENTO CARTA",
            "title_3": "TRATTAMENTO DATI",
            "title_4": "COME PREFERISCI ESSERE CONTATTATO",
            "title_5": "Autenticazione a due fattori",
            "stiboMaintenance": "Sito in Manutenzione",
            "stiboMaintenance1": "Servizio di Modifica Dati momentaneamente non disponibile per manutenzione in corso.",
            "stiboMaintenance2": "Ci scusiamo per il disagio. Si prega di riprovare più tardi.",
            "mfa1": "Abilitazione accesso tramite codice OTP (password numerica usa e getta).<br>Scegli l’opzione:",
            "mfa11": "Apri l’app di autenticazione, inquadra con la fotocamera il QRCODE per attivare l’autenticazione a due fattori. (puoi utilizzare Microsoft Authenticator",
            "mfa11a": " o Google Authenticator",
            "mfa11b": ") :",
            "mfa12": "Inserisci nel seguente riquadro il codice a 6 cifre generato dall’app (Microsoft Autenticator, Google Autenticator):",
            "mfatitle": "Autenticazione a due fattori avvenuta con successo!",
            "mfaError": "Errore di autenticazione",
            "mfaError1": "Ti invitiamo a riprovare il processo di attivazione dell'autenticazione a due fattori.",
            "mfaError2": "Il codice di verifica OTP ha una validità di 30 secondi ed una lunghezza di 6 cifre.",
            "mfa13App": "Complimenti! Salva ora i dati del Tuo Profilo Bennet e conserva la",
            "mfa14App": "configurazione nell’APP di Autenticazione per i prossimi accessi.",
            "mfa15App": "Ricorda che puoi sempre cambiare le tue impostazioni.",
            "mfa13Sms": "Complimenti! Salva ora i dati del Tuo Profilo Bennet ",
            "mfa14Sms": "Invieremo un SMS al tuo numero per i prossimi accessi.",
            "mfa15Sms": "Ricorda che puoi sempre cambiare le tue impostazioni.",
            "mfa21": "Clicca per generare il codice OTP e inviarlo via SMS<br><small>( Potrebbero essere applicate tariffe dal tuo operatore telefonico, verifica il tuo piano tariffario )</small>",
            "mfa22": "Invia OTP",
            "mfa23": "Inserisci qui sotto il codice a 6 cifre ricevuto tramite SMS",
            "mfa24": "Codice:",
            "mfa25": "Account:",
            "mfa26": "Tipo:",
            "mfa27": "In base all'ora",
            "p1": "Per il ritiro premi ",
            "p2": "Per ricevere le promozioni",
            //"p3": "Per la spesa online su BennetDrive",
            "p3": "Scegli tu in quale drive fare la spesa",
            "int0": "Auto",
            "int1": "Bambini",
            "int2": "Fai da te",
            "int3": "Gardinaggio",
            "int4": "Animali",
            "int5": "Bio e Salutistica",
            "int6": "Tecnologia",
            "int7": "Gourmet e Vini",
            "int8": "Sport e Tempo libero",
            "pvc0": "Privacy",
            "pvc1": "Marketing",
            "pvc2": "Profilazione",
            "pvc3": "Consenso Invio Mail",
            "pvc4": "Consenso Invio SMS/MMS",
            "pvc5": "Consenso Telefono",
            "pvc6": "Consenso Postalizzazione",
            "pvc7": "Consenso Invio Instant Message",
            "pvc0-detail": "Effettuando la registrazione dichiaro di aver letto e compreso l'INFORMATIVA SUL TRATTAMENTO DEI DATI.",
            "pvc1-detail": "Rispetto alla finalità G) di marketing diretto, per ricevere materiale informativo promozionale e pubblicitario relativo ai prodotti di Bennet Spa.",
            "pvc2-detail": "Rispetto alla finalità H) di profilazione, ossia ricevere comunicazioni promozionali e pubblicitarie di mio interesse correlate ai gusti manifestati in base ai miei acquisti.",
            "accept": "ACCETTO ",
            "not_accept": "NON ACCETTO "
        },
        "8": {
            "title": "RECUPERA CARTA",
            "message": "INSERISCI I TUOI DATI E TI VERRA’ INVIATA LA Carta PRESENTE NEL NOSTRO DATABASE",
            "phone_num": "Cellulare",
            "btn_label": "Torna a Registrati",
            "send": "Invia carta dimenticata alla tua mail all’indirizzo via sms",
            "reprint": "Ristampa la tua carta al box  informazioni !"
        },
        "9": {
            "title": "INZIA SUBITO LA TUA SPESA",
            "notification": "Il numero della Carta Bennet Club è stato inviato al tuo indirizzo di posta elettronica (qualora sia stato fornito) o al tuo numero di cellulare.",
            "sol1para1": "Riceverai una mail con la tua Carta all’indirizzo",
            "sol1para2": "Assieme ad una copia virtuale della Carta riceverai il regolamento e la privacy via mail.",
            "sol2para1": "Riceverai una SMS con il codice della tua Carta al numero",
            "sol2para2": "Potrai richiedere al box informazioni la stampa della tua Carta presentando l’SMS e avere copia della informativa sulla privacy che puoi sempre trovare su Bennet.com",
            "solution": "SOLUZIONE"
        }
    },
    "common": {
        "language": "italian",
        "name": "Nome",
        "surname": "Cognome",
        "next": "AVANTI",
        "ddn": "Data di nascita",
        "cf": "Codice Fiscale",
        "exit": "Esci senza salvare",
        "save": "SALVA",
        "cancel": "Annulla",
        "try": "Riprova",
        "required": "dato obbligatorio",
        "yes": "SI",
        "retrive": "RECUPERA",
        "modify": "Salva modifiche ",
        "use": "Usa",
        "invalid": "Invalido",
        "worning": "Attenzione",
        "updated": "aggiornato con successo",
        "error": "Errore",
        "not_recognized": "UTENTE NON RICONOSCIUTO",
        "confirm": "CONFERMA",
        "remit": "RIMETTI",
        "registrtaion": "registrazione",
        "control_inserted_fields": "CONTROLLA I CAMPI INSERITI ",
        "close": "Chiudi"
    },
    "alerts": {
        "alert_1": "L'utente è gia registrato con indirizzo email XXXX <br><br><span class ='small text-muted bolded'>  Se non ricordi i tuoi codici di accesso utilizza il servizio di RECUPERA PASSWORD o contatta il Servizio Clienti Bennet scrivendo a servizio.clienti@bennet.com o telefonando all’800236638</span>",
        "alert_2": "Il Codice Fiscale  XXXX è già in uso.<br> Ti preghiamo di contattare il Servizio Clienti Bennet all’800 236638 o scrivere a servizio.clienti@bennet.com",
        "alert_3": "L’email XXXX  è già in uso.<br> Ti preghiamo di contattare il Servizio Clienti Bennet all’800 236638 o scrivere a servizio.clienti@bennet.com",
        "alert_4": "Formato Email non valido per XXXX, formato corretto: example@example.it",
        "alert_5": "Il codice fiscale inserito non è coerente con i dati inseriti. <br>Ricontrolla i dati anagrafici e Codice Fiscale ",
        "alert_6": "Il numero XXXX risulta invalido.",
        "alert_7": "L'indirizzo email  XXXX risulta invalido.",
        "alert_8": "Ti abbiamo inviato un SMS con il codice di controllo al numero: XXXX",
        "alert_9": "Ti abbiamo inviato un Email con il codice di controllo all'indirizzo: XXXX",
        "alert_10": "Ti preghiamo di controllare che i dati personali e il numero della Carta Bennet Club siano correttamente inseriti.<br> <br>Ti preghiamo inoltre di verificare che Nome e Cognome corrispondano a quelli forniti all'emissione della Carta.<br> <br>Qualora la Carta sia stata creata da un familiare occorre inserire i suoi riferimenti anagrafici (nome e cognome).",
        "alert_11": "Hai già una Carta attiva, ti invitiamo a <strong>Recuperare la Carta </strong>.<br><br> Se smarrita contatta il Servizio Clienti al numero <a tabindex=\"-1\" href='tel:800236638'><strong>800236638</strong></a><br>Dal lunedì alla domenica <strong>dalle ore 09,00 alle ore 21,00</strong><br>Gratuito ad esclusione di chiamata da telefoni cellulari<br>Dall'estero <a tabindex=\"-1\" href='tel:+39 031 44 92 734' color:#6c757d >+39 031 44 92 734</a>.",
        "alert_12": "Il CAP dovrebbe essere composto da 5 numeri",
        "alert_13": "La password non soddisfa le regole",
        "alert_14": "La password di conferma non corrisponde alla password inserita",
        "alert_15": "Utente già presente in anagrafica con Carta attiva! Per maggiori informazioni contatta il Servizio Clienti Bennet scrivendo a servizio.clienti@bennet.com o telefonando all’800236638 ",
        "alert_16": "Il codice fiscale inserito non è coerente con i dati inseriti <br>Ricontrolla i dati anagrafici e Codice Fiscale",
        "alert_17": "In questo momento sono impossibilitato a ricevere comunicazioni via SMS",
        "alert_18": "Il codice inserito non è corretto",
        "alert_19": "Inserisci il codice per favore!",
        "alert_20": "Sei sicuro di voler recuperare le vecchie informazioni?",
        "alert_21": "Sei sicuro di voler uscire?<br><br><span class='small'> Perderai le informazioni appena inserite</span>",
        "alert_22": "Aggiornamento eseguito correttamente",
        "alert_23": "Non è possibile aggiornare le informazioni in questo momento. Ci scusiamo per il disagio",
        "alert_24": "Scegli il tuo bennet drive preferito",
        "alert_25": "Scegli il tuo Punto Vendita Preferito",
        "alert_26": "Scegli il tuo Punto Vendita di ritiro premi",
        "alert_27": "Scegli come preferisci essere contattato'",
        "alert_28": "Non è possibile proseguire senza il consenso Privacy",
        "alert_29": "Invio della mail non eseguito, ricontrolla la mail, deve essere la stessa con la quale ti sei registrato",
        "alert_30": "La richiesta è stata effettuata, a breve riceverai una mail per la scelta della nuova password ",
        "alert_31": "La password è stata resettata correttamente",
        "alert_32": "Errore tecnico. Ci scusiamo per il disagio",
        "alert_33": "ERRORE NEI DATI CARTA CONTATTA IL SERVIZIO CLIENTI",
        "alert_34": "Il CAP dovrebbe essere al massimo composto da 5 numeri",
        "alert_35": "Il Codice di controllo dovrebbe essere da 5 numeri",
        "alert_36": "Devi compilare tutti i dati obbligatori ",
        "alert_37": "L'email per il reset della password non è più valida. Richiedi un altro invio.",
        "alert_38": "Inserisci un indirizzo di Residenza Valido (obbligatorio selezionare una delle proposte).",
        "alert_39": "Il civico dovrebbe essere al massimo composto da 6 caratteri",
        "alert_40": "Formato Codice Fiscale non valido per XXXX",
        "alert_41": "Nome e Cognome devono avere al massimo 30 caratteri",
        "alert_42": "L'utente è già presente con un'altra tessera, se scegli di proseguire la card XXXX verrà disattivata perché hai già una tessera",       
        "alert_43": "Sei già registrato!" ,
        "alert_44": "Registrazione riservata a clienti maggiorenni",
        "alert_45": "Completa il processo di attivazione per l'autenticazione a due fattori oppure scegli 'No MFA' ",
        "alert_46": "Abbiamo inviato il codice OTP tramite SMS al numero: XXXX, controlla il tuo dispositivo.",
        "alert_47": "Non è stato possible inviare il codice OTP tramite SMS.Riprova più tardi.", 
        "alert_48": "Attenzione: La Password scelta non può essere uguale alla precedente."        
    }
}

export const LangLaib = {
    "ita": italian,
    "eng": english
}








// WEBPACK FOOTER //
// ./src/app/theme/models/languages.ts